import { supabase } from './supabase';

export const logsService = {
  async createLog(userId, userEmail, actionType, details, season = null) {
    try {
      const { error } = await supabase
        .from('admin_logs')
        .insert([{
          user_id: userId,
          user_email: userEmail,
          action_type: actionType,
          details: details,
          season: season,
          created_at: new Date().toISOString()
        }]);

      if (error) {
        console.error('Error creating log:', error);
        return { error };
      }

      return { success: true };
    } catch (err) {
      console.error('Unexpected error creating log:', err);
      return { error: err };
    }
  },

  async fetchLogs(filters = {}) {
    try {
      let query = supabase
        .from('admin_logs')
        .select('*')
        .order('created_at', { ascending: false });

      if (filters.season) {
        query = query.eq('season', filters.season);
      }

      if (filters.userEmail) {
        query = query.ilike('user_email', `%${filters.userEmail}%`);
      }

      if (filters.actionType) {
        query = query.eq('action_type', filters.actionType);
      }

      if (filters.startDate) {
        query = query.gte('created_at', filters.startDate);
      }

      if (filters.endDate) {
        query = query.lte('created_at', filters.endDate);
      }

      if (filters.limit) {
        query = query.limit(filters.limit);
      } else {
        query = query.limit(1000);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching logs:', error);
        return { error };
      }

      return { data };
    } catch (err) {
      console.error('Unexpected error fetching logs:', err);
      return { error: err };
    }
  },

  async getSeasons() {
    try {
      const { data, error } = await supabase
        .from('seasons')
        .select('name')
        .order('name', { ascending: false });

      if (error) {
        console.error('Error fetching seasons:', error);
        return { error };
      }

      const seasons = data
        .map(row => row.name)
        .filter(season => season !== null && season !== '');

      return { data: seasons };
    } catch (err) {
      console.error('Unexpected error fetching seasons:', err);
      return { error: err };
    }
  },

  async getActionTypes() {
    const actionTypes = [
      'STATS_CREATE',
      'STATS_UPDATE',
      'STATS_DELETE',
      'NEWS_CREATE',
      'NEWS_UPDATE',
      'NEWS_DELETE',
      'USER_CREATE',
      'USER_UPDATE',
      'USER_DELETE',
      'SEASON_CREATE',
      'SEASON_UPDATE',
      'PASSWORD_CHANGE',
      'LOGIN',
      'PERMISSION_UPDATE',
      'MEDIA_ANALYSIS_CREATE',
      'MEDIA_ANALYSIS_UPDATE',
      'MEDIA_ANALYSIS_DELETE',
      'create_webhook',
      'update_webhook',
      'delete_webhook',
      'toggle_webhook_status'
    ];

    return { data: actionTypes.sort() };
  }
};
